(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/logotype-provider-v2/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/content/logotype-provider-v2/assets/javascripts/prescript.js');

'use strict';

svs.content = svs.content || {};
svs.content.logotypeProviderV2 = svs.content.logotypeProviderV2 || {};


 })(window);